import { MasterAccountPermission, Permission } from '@insio/shared-types';
import { isMasterContext, useAuth, useMasterPermissions, usePermissions } from '@/features/auth';

/**
 * Whether the viewer is its payer's billing admin: `BILLING_MANAGE` in the account, or the master
 * account's `BILLING_MANAGE` on the board — the gate of every billing read and write.
 */
export function useCanManageBilling(): boolean {
  const { user } = useAuth();
  const { hasPermission } = usePermissions();
  const { hasMasterPermission } = useMasterPermissions();
  return isMasterContext(user)
    ? hasMasterPermission(MasterAccountPermission.BILLING_MANAGE)
    : hasPermission(Permission.BILLING_MANAGE);
}
